module.exports = __webpack_public_path__ + "static/media/trekspresso-3.d8c0b10f.jpg";